export default "__VITE_ASSET__Bx$J61uV__"